import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";
import SvgIcon from "@mui/material/SvgIcon";

import {featureInterface} from "../../../../interfaces/featureInterface";
import {setShowAddedToTheCartSuccess} from "../../../../actions/groheFunctions";
import {LookCartIcon} from "../../../common/icons";
import {getCartItemObject, getFeatureIsLocked} from "../../../../misc/helpers";
import {isInStock} from "../../lookNavigation/lookFunctions2";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import GroheFeatureSoldOut from "../../grohe/groheNavigation/groheFeature/groheFeatureSoldOut";
import GroheFeatureQuantity from "../../grohe/groheNavigation/groheFeature/groheFeatureQuantity";
import GroheFeatureSQFTButton from "../../grohe/groheNavigation/groheFeature/groheFeatureSQFTButton";
import {addToCart} from "../../../../actions/actionFunctions";

const ShopFeatureAddToCartComponents = (props) => {

  const {feature, setShowAddedToTheCartSuccess, isMobile, qtActiveCategory, addToCart, groheActiveFeatureQuantity} = props;

  const featureIsLocked = getFeatureIsLocked(feature);
  const disabled = (!featureIsLocked && !isInStock(feature));

  const shopAddToCartButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.shopFeatureAddToCart + (feature.dbFeature.sku || feature.dbFeature.sharedFeatureName));
    let newCartItem = getCartItemObject(feature, groheActiveFeatureQuantity, qtActiveCategory);
    newCartItem.keepOnLookUpdate = true;
    addToCart([newCartItem])
    setShowAddedToTheCartSuccess(true);
  }

  return (
    <Fragment>
      <div className="shop-feature__quantity">
        <GroheFeatureSQFTButton featureOpened={feature} className="shop-feature__quantity-sqft look-icon--ml-16"/>
        <GroheFeatureQuantity disabled={disabled} feature={feature} hideTitle={true}/>
      </div>
      {/*{isMobile ? (*/}
      {/*  <div className="shop-feature__sold">*/}
      {/*    <GroheFeatureSoldOut/>*/}
      {/*  </div>*/}
      {/*) : null}*/}
      <div className="shop-feature__cart">
        <Button className={"look-button look-button--10-radius look-button--42 look-button--blue look-button--no-transform look-button--max"
          + (isMobile ? " look-button--small" : " look-button--big")}
                disabled={disabled}
                startIcon={featureIsLocked ? null : <SvgIcon><LookCartIcon /></SvgIcon>}
                onClick={shopAddToCartButtonClick}>
          <FormattedMessage id={featureIsLocked ? "grohe.feature.unlockProductButton" : "grohe.feature.addToCartButton"}/>
        </Button>
        <GroheFeatureSoldOut disabled={disabled}/>
      </div>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {qtActiveCategory} = store.qtState;
  const {groheActiveFeatureQuantity} = store.groheState;

  return {
    isMobile,
    qtActiveCategory,
    groheActiveFeatureQuantity,
  };
};

const mapDispatchToProps = {
  setShowAddedToTheCartSuccess,
  addToCart,
};

ShopFeatureAddToCartComponents.propTypes = {
  feature: PropTypes.shape(featureInterface)
}

export default connect(mapStateToProps, mapDispatchToProps)(ShopFeatureAddToCartComponents)
